@if (src && !srcset && optimized) {
  <img
    class="image {{ borderRadius ? 'image--border-radius-' + borderRadius : '' }}"
    [ngSrc]="src"
    [ngSrcset]="fill ? (sizes ?? '1x') : '1x, 2x'"
    [sizes]="sizes"
    [alt]="alt"
    [width]="width"
    [height]="height"
    [ngClass]="{ 'image--fill': fill, 'image--full-width': fullWidth, 'image--full-height': fullHeight, 'image--circle': circle }"
    [fill]="fill"
    [ngStyle]="{ 'min-width': minWidth, 'max-width': maxWidth, 'min-height': minHeight, 'max-height': maxHeight, 'object-fit': objectFit, 'object-position': objectPosition }"
    [priority]="priority"
    (load)="load()"
    [app-preload-image]="preloadImageParent"
  />
} @else {
  <img
    class="image {{ borderRadius ? 'image--border-radius-' + borderRadius : '' }}"
    [src]="src"
    [alt]="alt"
    [width]="width"
    [height]="height"
    [ngClass]="{ 'image--fill': fill, 'image--full-width': fullWidth, 'image--full-height': fullHeight, 'image--circle': circle }"
    [ngStyle]="{ 'min-width': minWidth, 'max-width': maxWidth, 'min-height': minHeight, 'max-height': maxHeight, 'object-fit': objectFit, 'object-position': objectPosition }"
  />
}
